import { Link } from "react-router-dom";
import { ArrowUpRight, Home } from "lucide-react";
import { useSEO } from "../lib/seo";

export default function NotFound() {
  useSEO({
    title: "Página no encontrada | Victoria Fuentes, Psicóloga en Málaga",
    description: "La página que buscas no existe o ha cambiado de dirección. Vuelve al inicio o contacta con Victoria Fuentes, psicóloga sanitaria en Málaga.",
    path: typeof window !== "undefined" ? window.location.pathname : "/404",
    noindex: true,
  });

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-32 text-center" data-testid="not-found-page">
      <p className="overline">Error 404</p>
      <h1 className="mt-5 font-serif text-5xl font-light leading-tight text-ink md:text-7xl">Página no encontrada</h1>
      <p className="mt-6 max-w-md text-lg leading-relaxed text-ink-soft">
        Lo sentimos, la página que buscas no existe o ha cambiado de dirección.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 rounded-full bg-ink px-8 py-4 text-sm font-medium text-bg-primary transition-colors duration-300 hover:bg-sage-dark">
          <Home className="h-4 w-4" strokeWidth={1.5} /> Volver al inicio
        </Link>
        <Link to="/contacto" data-testid="notfound-contact" className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-8 py-4 text-sm font-medium text-ink transition-colors duration-300 hover:bg-ink/5">
          Contacto <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
        </Link>
      </div>
    </div>
  );
}
